export enum SubmissionTranslKey {
    ATTACHMENT_NOT_STAMPED = "submission:attachmentNotStamped",
    ATTACHMENT_NOT_STAMPED_HINT = "submission:attachmentNotStampedHint",
    AUTHORIZATION = "submission:authorization",
    AUTHORIZATION_COMPLETION_IN_PROGRESS = "submission:authorizationCompletionInProgress",
    AUTHORIZATION_REINITALIZATION_FAILED = "submission:authorizationReinitializationFailed",
    AUTHORIZATION_RESULT = "submission:authorizationResult",
    AUTHORIZATION_SERVICE_TEMPORARILY_UNAVAILABLE_RETRYING = "submission:authorizationServiceTemporarilyUnavailableRetrying",
    AUTHORIZATION_SERVICE_UNAVAILABLE_DIALOG_TITLE = "submission:authorizationServiceUnavailableDialogTitle",
    AUTHORIZATION_SERVICE_UNAVAILABLE_DIALOG_MESSAGE = "submission:authorizationServiceUnavailableDialogMessage",
    CERTIFICATION = "submission:certification",
    COVER_LETTER = "submission:coverLetter",
    CURRENT_STATE = "submission:currentState",
    DELIVERY_CHANNEL = "submission:deliveryChannel",
    DELIVERY_CHANNEL_EMAIL = "submission:deliveryChannelEmail",
    DELIVERY_CHANNEL_ISDS = "submission:deliveryChannelIsds",
    DELIVERY_CURRENT_STATE_TYPE = "submission:deliveryCurrentStateType",
    DELIVERY_RECIPIENT = "submission:deliveryRecipient",
    DELIVERY_RECIPIENT_TYPE = "submission:deliveryRecipientType",
    DELIVERY_RECIPIENT_TYPE_RECIPIENT = "submission:deliveryRecipientTypeRecipient",
    DELIVERY_RECIPIENT_TYPE_SENDER = "submission:deliveryRecipientTypeSender",
    DELIVERY_UPDATED_AT = "submission:deliveryUpdatedAt",
    DETAILS = "submission:details",
    DIGITAL_ACTION_AUTHORIZATION_MOCK = "submission:digitalActionAuthorizationMock",
    DIGITAL_ACTION_ID = "submission:digitalActionId",
    DOCUMENT_NUMBER = "submission:documentNumber",
    DOCUMENT_TYPE = "submission:documentType",
    DOCUMENTS = "submission:documents",
    DOCUMENTS_MANAGEMENT = "submission:documentsManagement",
    DOWNLOAD_PRINTABLE_DOCUMENT = "submission:downloadPrintableDocument",
    DOWNLOAD_SUBMISSION_CERTIFICATION = "submission:downloadSubmissionCertification",
    DOWNLOAD_SUBMISSION_COVER_LETTER = "submission:downloadSubmissionCertification",
    DOWNLOAD_SUBMITTED_DOCUMENT = "submission:downloadSubmittedDocument",
    GO_TO_DASHBOARD = "submission:goToDashboard",
    HISTORY = "submission:history",
    INITIALIZATION_OF_AUTHORIZATION_HAS_FAILED = "submission:initializationOfAuthorizationHasFailed",
    INITIALIZATION_OF_AUTHORIZATION_IN_PROGRESS = "submission:initializationOfAuthorizationInProgress",
    PRINTABLE_DOCUMENT = "submission:printableDocument",
    RECEIVED_DOCUMENT = "submission:receivedDocument",
    RECEIVED_DOCUMENTS = "submission:receivedDocuments",
    RECENT_SUBMISSIONS_PANEL_TITLE = "submission:recentSubmissionsPanelTitle",
    RETRY_AUTHORIZATION = "submission:retryAuthorization",
    SIMULATE_AUTHORIZATION_STARTUP_OUTAGE = "submission:simulateAuthorizationStartupOutage",
    SIMULATE_AUTHORIZATION_STARTUP_OUTAGE_ACTIVE_HINT = "submission:simulateAuthorizationStartupOutageActiveHint",
    SIMULATE_AUTHORIZATION_STARTUP_OUTAGE_DESCRIPTION = "submission:simulateAuthorizationStartupOutageDescription",
    SIMULATE_AUTHORIZATION_STARTUP_OUTAGE_ENABLE = "submission:simulateAuthorizationStartupOutageEnable",
    SIMULATE_AUTHORIZATION_STARTUP_OUTAGE_DISABLE = "submission:simulateAuthorizationStartupOutageDisable",
    SUBMISSION_AUTHORIZATION_COMPLETION = "submission:submissionAuthorizationCompletion",
    SUBMISSION_AUTHORIZATION_RESULT = "submission:submissionAuthorizationResult",
    SUBMISSION_NOT_READY_FOR_AUTHORIZATION = "submission:submissionNotReadyForAuthorization",
    SUBMISSION_NOT_READY_FOR_AUTHORIZATION_DIALOG_TITLE = "submission:submissionNotReadyForAuthorizationDialogTitle",
    SUBMISSION_NOT_READY_FOR_AUTHORIZATION_DIALOG_MESSAGE = "submission:submissionNotReadyForAuthorizationDialogMessage",
    SUBMISSION_DELIVERY = "submission:submissionDelivery",
    SUBMISSION_DELIVERY_STILL_IN_PROGRESS = "submission:deliveryStillInProgress",
    SUBMISSION_DETAILS = "submission:submissionDetails",
    SUBMISSION_PORTAL_DEFAULT = "submission:submissionPortalDefault",
    SUBMISSION_PORTAL_DEFAULT_SHORT = "submission:submissionPortalDefaultShort",
    SUBMISSION_PORTAL_MO = "submission:submissionPortalMo",
    SUBMISSION_PORTAL_MO_SHORT = "submission:submissionPortalMoShort",
    SUBMISSION_PORTAL_MV = "submission:submissionPortalMv",
    SUBMISSION_PORTAL_MV_SHORT = "submission:submissionPortalMvShort",
    SUBMISSION_REDELIVER_DELIVERY_BTN = "submission:redeliverDeliveryButton",
    SUBMISSION_REDELIVER_DELIVERY_DIALOG_MSG = "submission:redeliverDeliveryDialogMessage",
    SUBMISSION_REDELIVER_DIALOG_TITLE = "submission:redeliverDialogTitle",
    SUBMISSION_REDELIVER_FAILED = "submission:redeliverFailed",
    SUBMISSION_REDELIVER_PARTIALLY_FAILED = "submission:redeliverPartiallyFailed",
    SUBMISSION_REDELIVER_REQUESTED = "submission:redeliverRequested",
    SUBMISSIONS_MISSING_ATTACHMENT_TYPES = "submission:submissionsMissingAttachmentTypes",
    SUBMISSIONS_STATE_UPDATED_FROM = "submission:submissionStateUpdatedAtFrom",
    SUBMISSIONS_STATE_UPDATED_TO = "submission:submissionStateUpdatedAtTo",
    SUBMITTED_AT = "submission:submittedAt",
    SUBMISSIONS_SUBMITTED_AT_FROM = "submission:submittedAtFrom",
    SUBMISSIONS_SUBMITTED_AT_TO = "submission:submittedAtTo",
    SUBMITTED_BY = "submission:submittedBy",
    SUBMISSIONS_TO_AUTHORIZE = "submission:submissionsToAuthorize",
    SUBMISSIONS_TO_AUTHORIZE_ACTION = "submission:submissionsToAuthorizeAction",
    SUBMISSIONS_TO_AUTHORIZE_ACTION_NAME = "submission:submissionsToAuthorizeActionName",
    SUBMIT_AUTHORIZATION_RESULT = "submission:submitAuthorizationResult",
    SUBMITTED_DOCUMENT = "submission:submittedDocument",
    SUBMITTED_DOCUMENT_ATTACHMENT = "submission:submittedDocumentAttachment",
}
